import { render, staticRenderFns } from "./FormPageUnitDbtr.vue?vue&type=template&id=d65458a2&scoped=true&"
import script from "./FormPageUnitDbtr.vue?vue&type=script&lang=js&"
export * from "./FormPageUnitDbtr.vue?vue&type=script&lang=js&"
import style0 from "./FormPageUnitDbtr.vue?vue&type=style&index=0&id=d65458a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65458a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d65458a2')) {
      api.createRecord('d65458a2', component.options)
    } else {
      api.reload('d65458a2', component.options)
    }
    module.hot.accept("./FormPageUnitDbtr.vue?vue&type=template&id=d65458a2&scoped=true&", function () {
      api.rerender('d65458a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/FormPageUnitDbtr.vue"
export default component.exports